import React from "react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
export function IntroSection() {
  return <section className="bg-canvas px-4 py-16 sm:px-6 sm:py-20" data-id="element-176" data-mp="3a8xmnqnqyx5x">
      <div className="mx-auto max-w-3xl" data-id="element-177" data-mp="3f78y25toxfq9">
        <SectionHeading kicker="The CAN Bus Diagnostic Blueprint™ Collection" title="Six Volumes. Five Professional Bonuses. One Structured Approach." data-id="element-178" data-mp="3f67efcylzkwx" />

        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-179" data-mp="3p56n2vjdjgjx">
          <p data-id="element-180" data-mp="3t5yurkcllde3">
            If you work with automotive electronics, you already know how frustrating communication faults can be.
          </p>
          <p data-id="element-181" data-mp="6rp9vl7vmni2">You connect your diagnostic equipment. You read the fault codes. You inspect the available information.</p>
          <p data-id="element-182" data-mp="brbmptjsm1qc">But then you face the question that separates an organized investigation from an improvised one:</p>
        </div>

        <blockquote className="my-8 rounded-2xl bg-night px-6 py-8 text-center" data-id="element-183" data-mp="gqo96d6r56se">
          <p className="font-display text-3xl font-black text-white sm:text-4xl" data-id="element-184" data-mp="l22q6ikictx3">
            “What should I check <span className="text-gold" data-id="element-185" data-mp="g2ga81daozkl">next?</span>”
          </p>
        </blockquote>

        <div className="space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-186" data-mp="b33fyvk3gq7z">
          <p data-id="element-187" data-mp="72b5jyzhkfa4">
            That's exactly why I created the <strong className="text-ink" data-id="element-188" data-mp="73m9bysxln18">CAN Bus Diagnostic Blueprint</strong>.
          </p>
          <p data-id="element-189" data-mp="13qzco09nyi4r">
            Instead of leaving you with disconnected technical information, I designed a structured collection of
            visual workflows, decision frameworks, and documentation tools to help you organize your investigation
            and make your next diagnostic decision <strong className="text-ink" data-id="element-190" data-mp="pzuihdp2ei1t">based on evidence</strong>.
          </p>
        </div>

        <div className="mt-10" data-id="element-191" data-mp="1mj1xlntc8kkt">
          <CtaButton label="Get instant access for $27" sublabel="One-Time Payment · No Monthly Fees · Lifetime Access" data-id="element-192" data-mp="1mk35jjf24qyb" />
        </div>
      </div>
    </section>;
}